import { render } from "./Step2.vue?vue&type=template&id=5bb6ac76&scoped=true"
import script from "./Step2.vue?vue&type=script&lang=js"
export * from "./Step2.vue?vue&type=script&lang=js"

import "./Step2.vue?vue&type=style&index=0&id=5bb6ac76&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb6ac76"]])

export default __exports__